import { defineMessages } from '@atlassian/jira-intl'; // This is to reuse translations in growth component
/* eslint-disable jira/i18n/id-named-by-package */

const messages = defineMessages({
	enabled: {
		id: 'opsgenie-schedule.components.opsgenie-schedule-component.schedule-timeline.enabled',
		defaultMessage: 'Enabled',
		description: 'Status text of a Opsgenie schedule',
	},
	disabled: {
		id: 'opsgenie-schedule.components.opsgenie-schedule-component.schedule-timeline.disabled',
		defaultMessage: 'Disabled',
		description: 'Status text of a Opsgenie schedule',
	},
	viewInOpsgenie: {
		id: 'opsgenie-schedule.components.opsgenie-schedule-component.schedule-timeline.view-in-opsgenie',
		defaultMessage: 'View in Opsgenie',
		description: 'A link placed in a schedule for user to view it in Opsgenie.',
	},
});

export default messages;
